import { Route, Switch as RRDSwitch, useRouteMatch } from 'react-router-dom';

import NewObject from './features/NewObject';
import ExistingObject from './features/ExistingObject';
import ObjectsList from './features/ObjectsList';
import ObjectsBulkUpdate from './features/ObjectsBulkUpdate';
import SuggestedObjectsList from './features/SuggestedObjectsList';
import SuggestedObject from './features/SuggestedObject';


const Switch = () => {
  // const { path } = useRouteMatch();

  return (
    <RRDSwitch>
      <Route path="/objects/new">
        <NewObject />
      </Route>
      <Route path="/objects/bulk-update">
        <ObjectsBulkUpdate />
      </Route>
      <Route
        path="/objects/:id"
        render={({
          match: {
            params: { id },
          },
        }) => <ExistingObject id={id?.trim()} />}
      />
      <Route path="/objects">
        <ObjectsList />
      </Route>

      <Route
        path="/objects-suggested/:id"
        render={({
          match: {
            params: { id },
          },
        }) => <SuggestedObject id={id?.trim()} />}
      />
      <Route path="/objects-suggested">
        <SuggestedObjectsList />
      </Route>
    </RRDSwitch>
  );
};

export default Switch;
